import styled, { css } from 'styled-components';

import { colors } from 'global/colors';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  padding: 0;
`;

export const HeaderContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  margin-bottom: 10px;

  @media (max-width: 768px) {
    flex-direction: column;
    height: 75px;
  }
`;

export const RightHeaderContainer = styled.div`
  display: flex;
  width: 100%;
  justify-content: flex-end;
  align-items: center;
  @media (max-width: 768px) {
    justify-content: flex-end;
    margin-top: 4px;
  }
`;

export const SortByLabel = styled.span`
  font-size: 15px;
  color: ${colors.darkGray};
  margin: 0 5px 0;
`;

export const LeftContainer = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 220px;
  margin-right: 10px;

  @media (max-width: 576px) {
    margin-right: 0;
    margin-bottom: 10px;
  }
`;

export const RightContainer = styled.div`
  width: 100%;
`;

export const ContentContainer = styled.div`
  margin-top: 0.5rem;
  display: flex;

  @media (max-width: 576px) {
    flex-direction: column;
  }
  ${(props) =>
    props.center &&
    css`
      justify-content: center;
    `}
`;

export const TopListContainer = styled.div`
  background: ${colors.white};
  border-radius: 5px;
  width: 100%;
  display: flex;
  overflow: scroll;
  flex-direction: column;
  box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.1);
  max-height: 400px;
`;

export const TopListAvatar = styled.div`
  background: url(${(props) => props.image});
  background-position: center center;
  background-size: cover;
  background-repeat: no-repeat;
  border-radius: 50%;
  width: ${(props) => props.size || '42'}px;
  height: ${(props) => props.size || '42'}px;
  margin-right: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: ${(props) => props.size / 2 || '18'}px;
  color: ${colors.white};
  font-weight: bold;
  text-shadow:
    -1px 0 black,
    0 1px black,
    1px 0 black,
    0 -1px black;
  user-select: none;
`;

export const TopListTable = styled.table`
  overflow-y: scroll;
`;

export const TopListTableRow = styled.tr`
  background: #efefef;
  border-bottom: 1px solid ${colors.white};

  :last-child {
    border-bottom: none;
  }

  ${(props) =>
    props.alternateRow &&
    css`
      background: #dedede;
    `}

  ${(props) =>
    props.isSelf &&
    css`
      background: #c7dded;
    `}
`;

export const TopListTableHead = styled.thead``;

export const TopListTableBody = styled.tbody``;

export const TopListTableHeader = styled.th`
  text-align: left;
  color: #888;
  font-weight: 300;
  padding: 5px 0;
  margin-right: 10px;
  position: sticky;
  top: 0;
  z-index: 2;
  background: ${colors.white};
  user-select: none;

  :first-child {
    padding-left: 10px;
    width: 60px;
  }

  ${(props) =>
    props.width &&
    css`
      width: ${props.width}px;
    `}

  ${(props) =>
    props.center &&
    css`
      text-align: center;
    `}
`;

export const TopListTableCell = styled.td`
  text-align: left;
  height: 55px;
  padding: 0;
  margin-right: 10px;

  :first-child {
    padding-left: 7px;
  }

  :last-child {
    > div {
      padding: 0;
    }
  }
`;

export const TopListLabel = styled.span`
  font-size: 18px;
  color: #555;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  ${(props) =>
    props.isSelf &&
    css`
      font-weight: bold;
    `}
`;
